import { render } from "./TopMerchantsChart.vue?vue&type=template&id=676b91c5&scoped=true"
import script from "./TopMerchantsChart.vue?vue&type=script&lang=js"
export * from "./TopMerchantsChart.vue?vue&type=script&lang=js"

import "./TopMerchantsChart.vue?vue&type=style&index=0&id=676b91c5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-676b91c5"]])

export default __exports__